import get from "lodash/get";
import {
    GAME_COMPARISON_PERIODS,
    GAME_PRODUCT_TYPES,
} from "constants/Games/GameConstants";

export function getNameForGameComparisonPeriod(period) {
    switch (period) {
        case GAME_COMPARISON_PERIODS.YOY:
            return "Year-over-Year";
        case GAME_COMPARISON_PERIODS.ROLLING:
            return "Rolling Period";
    }

    return period;
}

export function getCategoryNameForGameType(productType) {
    switch (productType) {
        case GAME_PRODUCT_TYPES.THERAPEUTIC:
            return "Other"
        case GAME_PRODUCT_TYPES.PARASITICIDE:
            return "Parasiticide Products";
        case GAME_PRODUCT_TYPES.DENTAL:
            return "Dental Products";
        case GAME_PRODUCT_TYPES.NSAID:
            return "NSAIDs";
    }

    return productType;
}

export function getCategoryIdForGameProductType(productType) {
    switch (productType) {
        case GAME_PRODUCT_TYPES.PARASITICIDE:
            return 30;
        case GAME_PRODUCT_TYPES.DENTAL:
            return 60;
        case GAME_PRODUCT_TYPES.NSAID:
            return 20;
        case GAME_PRODUCT_TYPES.NUTRACEUTICAL:
            return 70;
        case GAME_PRODUCT_TYPES.SERVICE:
            return 50;
        case GAME_PRODUCT_TYPES.THERAPEUTIC:
            return 40;
        default:
            return null;
    }
}

/**
 * This function is used to get the name for the game duration.
 * It handles both string and number inputs.
 * @param {*} duration - The duration of the game.
 * @returns The name for the game duration.
 */
export function getNameForGameDuration(duration) {
    const durationNum = Number(duration);
    
    // If it's a valid number, use the numeric format
    if (!isNaN(durationNum)) {
        return `${durationNum} Days`;
    }
    
    // If it's not a valid number, treat it as a string and append "Days"
    return `${duration} Days`;
}
